import * as React from "react";
import styled from "../../../styled/index";
import { BaseInputCSS } from "../input/index";

const SelectComponent = styled("select") <T.Lib.Form.Select.SelectProps>`
  ${BaseInputCSS};
  option {
    padding: 5px 0;
    &:disabled {
      background-color: darken(white, 15%);
    }
  }
`;

export const Select = (props: T.Lib.Form.Select.SelectProps) => (
	<SelectComponent {...props}>
		{props.placeholder && <option value="">{props.placeholder || ""}</option>}
		{props.options.map((o, i) => {
			return (<option key={i} value={o.value} disabled={o.disabled || false}>{o.label}</option>);
		})}
	</SelectComponent>
);
